export const getManualCommonBuilding = (
  declarationRequest,
  main_building,
  id,
) => {
  return {
    filter_search_type: parseInt(
      declarationRequest?.unit?.filter_search_type_id,
    ),
    manual_governorate_id: declarationRequest?.unit?.manual_governorate_id,
    manual_policestation_id: declarationRequest?.unit?.manual_policestation_id,
    manual_policestation_name:
      declarationRequest?.unit?.manual_policestation_name,
    manual_city: declarationRequest?.unit?.manual_city,
    manual_district: declarationRequest?.unit?.manual_district,
    manual_mogawra: declarationRequest?.unit?.manual_mogawra,
    manual_village: declarationRequest?.unit?.manual_village,
    manual_street: declarationRequest?.unit?.building?.manual_street,
    manual_settlement: declarationRequest?.unit?.manual_settlement,
    manual_known_build_num:
      main_building === 1
        ? declarationRequest?.unit?.manual_known_build_num
        : declarationRequest?.unit?.building?.building_manual_known_build_num,
    manual_renin: declarationRequest?.unit?.building?.manual_renin,
    main_building: main_building,
    id,
  };
};
